import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Progress.module.css";
/**
 * Barra de progresso do Azim CRM.
 */
export function Progress({ value = 0, tone = "accent", height = 6, className, style, "aria-label": ariaLabel, }) {
    const clampedValue = Math.max(0, Math.min(100, value));
    return (_jsx("div", { className: [styles.track, className ?? ""].filter(Boolean).join(" "), style: { height, ...style }, role: "progressbar", "aria-valuenow": clampedValue, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": ariaLabel ?? "Progresso", children: _jsx("div", { className: `${styles.fill} ${styles[tone]}`, style: { width: `${clampedValue}%`, height } }) }));
}
//# sourceMappingURL=Progress.js.map